import React from 'react'
import { func } from 'prop-types'
import { FormattedMessage } from 'react-intl'

import useInternationalization from '@hooks/useInternationalization'
import Form from '../../components/Form'

import * as Style from './Main.style'

export default function Main({ handleForm }) {
  const { country } = useInternationalization()

  return (
    <Style.MainWrapper>
      <Style.Container>
        <Style.WarningContainer>
          <Style.Warning>
            <FormattedMessage
              id="smb_acquisition_broker_company_info.page.warning_section.title"
              values={{
                a: (...chunks) => (
                  <a href={`https://www.gympass.com/digital/${country}`}>
                    {chunks}
                  </a>
                ),
              }}
            />
          </Style.Warning>
        </Style.WarningContainer>
        <Style.Title>
          <FormattedMessage id="smb_acquisition_broker_company_info.page.title" />
        </Style.Title>

        <Style.Subtitle>
          <FormattedMessage id="smb_acquisition_broker_company_info.page.subtitle" />
        </Style.Subtitle>

        <Form onSubmit={handleForm} />
      </Style.Container>
    </Style.MainWrapper>
  )
}

Main.propTypes = {
  handleForm: func.isRequired,
}
